import { PHPersonalIntentOptions } from '../../enums';
import { GenericCheckboxStep } from '../steps';

function PHPersonalIntentStep() {
  return (
    <GenericCheckboxStep
      title="How can a tax pro best support you?"
      subtitle="Select all that apply."
      checkboxOptions={PHPersonalIntentOptions}
      referralFieldName="ph_personal_intents"
    />
  );
}

export { PHPersonalIntentStep };
